<app-spin-or-content [isSpin]="isLoading">
	<div class="row">
		<div class="col-12">
			<app-gen-button-group
				[actualObj]="this"
				fieldName="userActiveStatus"
				optionsListName="user_active_opts"
				(changeEvent)="filterRows()"
			></app-gen-button-group>
		</div>
	</div>
	<div class="row">
		<div class="col-12">
			<app-gen-button-group
				[actualObj]="this"
				fieldName="optStatus"
				optionsListName="patient_active_opts"
				(changeEvent)="filterRows()"
			></app-gen-button-group>
		</div>
	</div>
	<div class="modal-btns">
		@if (isModalMode) {
			<app-cancel-btn (click)="close()" />
		}
		<button
			tabindex="1"
			class="btn btn-primary"
			(click)="print()"
		>
			{{ "print" | langVal }}
		</button>
		<!--      <button tabindex="-1" class="btn  btn-primary"-->
		<!--              (click)="downloadReport()">{{"create_excel" | langVal}}</button>-->
		<button
			tabindex="1"
			class="btn btn-primary"
			[disabled]="!checkedIds.length"
			[spinner]="isDeactivatingAll"
			(click)="deactivateAll()"
		>
			{{ "make_not_active" | langVal }}
		</button>
	</div>
	<div
		id="section-to-print"
		class="sub-user-patients"
	>
		<app-table-wrap
			fieldsStr=",id,name,active,,active_assoc,patient_status,assoc_date"
		>
			@for (row of rowsShown; track row) {
				<tr [class.subtotal]="row.isSubTotal">
					<td>
						@if (!row.isSubTotal) {
							<app-yes-no
								(onClick)="check(row.id)"
								[isCheck]="checkedIds.includes(row.id)"
							/>
						}
					</td>
					<td>{{ row.item_id }}</td>
					<td [class.link-patient]="!row.isSubTotal">
						<app-patient-modal [id]="row.item_id">
							{{ row.name }}
						</app-patient-modal>
					</td>
					<td>{{ row.patientActive | langVal }}</td>
					<td>
						@if (row?.patient?.active == "yes") {
							<button
								class="btn btn-primary print_hidden"
								(click)="deactivate(row)"
							>
								{{ "make_not_active" | langVal }}
							</button>
						}
					</td>

					<td>{{ row?.active | langVal }}</td>
					<td style="width: 10%">{{ row.status | langVal }}</td>
					<td>{{ row.created_at | dateFormat }}</td>
					<!--          <td>{{row.first_followup_time | dateFormat}}</td>-->
					<!--          <td>{{row.last_followup_time | dateFormat}}</td>,first_meeting_date,last_meeting_date-->
				</tr>
			}
		</app-table-wrap>
	</div>
</app-spin-or-content>
